import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "description" }
const _hoisted_2 = { class: "btn-box" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 取消 ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 确认 ")


const __default__ = {
  name: 'CustomDialog'
};

import {withDefaults, computed} from 'vue';
import {Dialog, Button} from 'vant';
import {usePopReturn} from '@/hooks/usePopReturn';


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    title: { default: '提示' },
    description: null,
    show: { type: Boolean },
    toggleShowDialog: null,
    onConfirm: null,
    teleport: null
  },
  setup(__props: any) {

const props = __props as { title: string, description: string, show: boolean, toggleShowDialog:(show: boolean) => void, onConfirm: () => void, teleport?: string }

const VanDialog = Dialog.Component;



const showDraft = computed({
  get() {
    return props.show;
  },
  set(val: boolean) {
    props.toggleShowDialog(false);
  },
});

const handleConfirm = () => {
  props.toggleShowDialog(false);
  props.onConfirm();
};

const {handleClose, handleOpen} = usePopReturn(showDraft, () => {
  props.toggleShowDialog(false);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(VanDialog), {
    show: _unref(showDraft),
    "onUpdate:show": _cache[1] || (_cache[1] = ($event: any) => (_isRef(showDraft) ? (showDraft).value = $event : null)),
    teleport: __props.teleport ? __props.teleport : null,
    title: __props.title,
    "show-confirm-button": false,
    class: "__confirm_dialog-box",
    onOpen: _unref(handleOpen),
    onClose: _unref(handleClose)
  }, {
    default: _withCtx(() => [
      _createElementVNode("span", _hoisted_1, _toDisplayString(__props.description), 1),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(Button), {
          type: "primary",
          class: "cancel-btn",
          round: "",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (__props.toggleShowDialog(false)))
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }),
        _createVNode(_unref(Button), {
          type: "primary",
          class: "confirm-btn",
          round: "",
          onClick: handleConfirm
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["show", "teleport", "title", "onOpen", "onClose"]))
}
}

})